<template>
  <v-tabs>
    <v-tab
      :to="{
        name: 'PatientRecordProgressStatusJourney',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("buttons.journey", {catalog: 'app_mobile'})) }}
    </v-tab>
    <v-tab
      :to="{
        name: 'PatientRecordProgressStatusParameters',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("journeyProgress.parameters")) }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * Component JourneyProgressTabs.vue
 *
 * @module JourneyProgressTabs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/JourneyProgressTabs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "JourneyProgressTabs",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
  },
};
</script>

<style lang="scss">
</style>
